export default function addTrailingSlash(url) {
  return url.endsWith('/') ? url : `${url}/`;
}
